import React from "react";
import { Clock, MapPin, AlertCircle, CalendarCheck } from "lucide-react";

const UpcomingEvents = ({
  filteredUpcomingEvents,
  loading,
  styles,
  screenSize,
  language,
  theme,
  t,
  onEventClick,
}) => {
  const locale = language === "ar" ? "ar-EG" : "en-US";

  // "Today" / "Tomorrow" read faster than "Mon, 14 Sep" for the two dates
  // that matter most in a seven-day list.
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const today = startOfDay(new Date());

  const dayLabel = (d) => {
    const diff = Math.round((startOfDay(d) - today) / 86400000);
    if (diff === 0) return t.today;
    if (diff === 1) return t.tomorrow;
    return d.toLocaleDateString(locale, {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  };

  return (
    <div style={styles.sidebarCard}>
      <h3 style={styles.sidebarTitle}>
        <Clock size={18} /> {t.upcomingEvents}
        {filteredUpcomingEvents.length > 0 && (
          <span style={styles.sectionCount}>{filteredUpcomingEvents.length}</span>
        )}
      </h3>

      {loading ? (
        <div style={{ textAlign: "center", padding: "24px 0" }}>
          <div style={styles.loadingSpinner} />
        </div>
      ) : filteredUpcomingEvents.length === 0 ? (
        <div style={styles.emptyStateCompact}>
          <CalendarCheck style={styles.emptyIconCompact} />
          <h4 style={styles.emptyTitleCompact}>{t.noUpcomingEvents}</h4>
          <p style={{ ...styles.emptyDescription, fontSize: "12.5px" }}>
            {t.calendarClear}
          </p>
        </div>
      ) : (
        filteredUpcomingEvents.map((ev) => {
          const evDate = new Date(`${ev.date}T00:00:00`);

          return (
            <div
              key={ev.id}
              className="upcoming-item"
              style={styles.upcomingItem}
              onClick={() => onEventClick(ev)}
            >
              {/* Date block carries the event-type colour, so the list and
                  the grid speak the same colour language. */}
              <div style={styles.upcomingDateChip(ev.color)}>
                <span style={styles.upcomingDateDay}>{evDate.getDate()}</span>
                <span style={styles.upcomingDateMonth}>
                  {evDate.toLocaleDateString(locale, { month: "short" })}
                </span>
              </div>

              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={styles.upcomingTitle}>{ev.title}</div>

                <div style={styles.upcomingMeta}>
                  <Clock size={13} style={{ flexShrink: 0 }} />
                  <span>
                    {dayLabel(evDate)}
                    {ev.time ? ` · ${ev.time}` : ""}
                  </span>
                </div>

                {ev.location && (
                  <div style={styles.upcomingMeta}>
                    <MapPin size={13} style={{ flexShrink: 0 }} />
                    <span
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {ev.location}
                    </span>
                  </div>
                )}

                {ev.priority === "urgent" && (
                  <span style={styles.upcomingUrgentTag}>
                    <AlertCircle size={12} />
                    {t.urgent}
                  </span>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default UpcomingEvents;
